import { call, get, put, select } from "redux-saga/effects";
import * as bannerAction from "../actions/banner";
import api from "../services/httpUtilities/httpService";
import httpErrorHelpers from "../services/httpUtilities/httpErrorHelpers";

function* watcherGetBannerRequest() {
    try {
        const response = yield call(api.getAppPopUp);
        const { items } = response.data;

        if (response.status === 200) {
            yield put(bannerAction.getBannerSuccess(items));
        }
    } catch (error) {
        yield call(
            httpErrorHelpers,
            error,
            bannerAction.getBannerFailure
        );
    }
}

function* watcherDismissBannerRequest() {
    yield put(bannerAction.dismissBannerSuccess());
}

export {
    watcherGetBannerRequest,
    watcherDismissBannerRequest,
};



// WEBPACK FOOTER //
// ./src/sagas/banner.js